<div>
  <div [ngClass]="tenantGenericConfig?.tenant === 'VOT' ? 'd-grid grid-column-validops align-items-center' : 'd-grid grid-column align-items-center'">
    <div class="d-grid grid-column">
      <div class="d-flex flex-column justify-content-center w-100">
        <div [ngClass]="tenantGenericConfig?.tenant === 'VOT' ? 'd-flex ai-center gap-4' : 'd-flex ai-center'">
          <div [ngClass]="tenantGenericConfig?.tenant === 'VOT' ? 'vehicle-profile-header-tile-validops uni-profile-header-tile' : 'vehicle-profile-header-tile'">{{ content?.uniqueId }}</div>
          <div class="widget-status" [style.background-color]= "getOperationalStatusName(content?.operationalStatus)?.selectedBgColor" [style.color]= "getOperationalStatusName(content?.operationalStatus)?.textColor" *ngIf="content?.operationalStatus">{{getOperationalStatusName(content?.operationalStatus)?.name | titlecase}}</div>
          <sup *ngIf="content?.assetDetails?.state"
            class="{{ content?.assetDetails?.state }} sup-cont">{{ getStateLabel(content?.assetDetails?.state) }}</sup>
        </div>
      </div>
    </div>
    <div class="score ml-auto d-flex  align-items-center justify-content-center" *ngIf="tenantGenericConfig?.entityCardView !== 'VALIDOPS_VEHICLE_TRACK'">
      <div *ngIf="content?.secondaryDetails?.['brandLogo']" class="mr-2">
        <img src="{{ content?.secondaryDetails?.['brandLogo'] + token }}" class="h-25 img-fluid" alt="logo">
      </div>
      <div class="mr-2"
        [ngClass]="{'category-panel-right': (tenantGenericConfig?.tenant === 'TRL' ||  tenantGenericConfig?.tenant === 'DMK'), 'generic-iconstyle': (tenantGenericConfig?.tenant !== 'TRL' && tenantGenericConfig?.tenant !== 'DMK')}">
        <img src="{{ tenantGenericConfig?.tenant === 'TRL' ? entityIconContent?.imgUrl : (entityIconContent?.imgUrl + token) }}"
          [hidden]="(content?.type == 3 && content?.category == 'patient') || content?.category == 'monotainer'"
          [alt]="entityIconContent?.altName"
          [matTooltip]="content?.type === 1 ? 'Vehicle Category:'+entityIconContent?.altName : entityIconContent?.altName"
          class="img-align"
          [ngClass]="{'trl-img-fit': tenantGenericConfig?.tenant === 'TRL', 'dmk-img-fit': tenantGenericConfig?.tenant === 'DMK'}">

      </div>
      <div class="d-flex align-items-center justify-content-center flex-column"
        *ngIf="content?.type === 1 && tenantGenericConfig?.tenant !== 'TRL'">
        <div class="ft-20 d-flex">
          <img src="../../../../assets/images/star-solid.svg" class="w-20 opacity3 space-after-icon star" title="Vehicle Score" alt="Make">
          <strong class="ft-20">90</strong>
        </div>
        <div class="ft-12">Excellent</div>
      </div>
    </div>
    <div *ngIf="taggable">
      <mat-checkbox class="field checkbox-width" (click)="$event.stopPropagation();"
        (change)="onTagOptionChanged(content?._id, $event)">
      </mat-checkbox>
    </div>
    <div *ngIf="service?.rbacManagement('entities_EntityEdit')" [ngClass]="{'disabled': !siteId}" [matTooltip]="!siteId ? 'Select site to enable edit feature' : 'Edit'">
      <img src="../../../../assets/images/Delete-Edit.svg" alt="Edit" (click)="onMatCardClick($event,content?._id)" />
    </div>
  </div>
</div>